import React from 'react';

import { LightSeparatorProps } from './light-separator-type';

import styles from './light-separator-component.module.css';

export const LightSeparator: React.FC<LightSeparatorProps> = ({ withMargin }: LightSeparatorProps) => {
    return <hr className={styles.partHr} style={{ marginBottom: withMargin ? '15px' : '' }} />;
};
